import React, { useCallback } from 'react';
import {
  FormLabel,
  FormControl,
  ListItemText,
  FormHelperText,
  ListItemButton,
} from '@mui/material';
import { MeetingList, MeetingItem } from 'components/meetings-list';
import style from './index.module.scss';
import { dateFormat } from 'utils/dates';
import { useTranslate } from 'hooks/use-translate';

interface Props {
  error?: boolean;
  label?: React.ReactNode;
  helperText?: React.ReactNode;
  value: string;
  onChange: (value: string | null) => void;
  disabled?: boolean;
  options: MeetingItem[];
}
export const AppInputMeetingListSelect: React.FC<React.PropsWithChildren<Props>> = ({
  error,
  label,
  helperText,
  value,
  onChange,
  disabled,
  options,
}) => {
  const { tp } = useTranslate();

  const handleChangeMeetingToday = useCallback(() => {
    onChange('today');
  }, [onChange]);

  const handleChangeMeeting = useCallback(
    (v: string | null) => {
      onChange(v);
    },
    [onChange],
  );

  return (
    <FormControl className={style.root} error={error} fullWidth component="fieldset">
      {label && <FormLabel component="legend">{label}</FormLabel>}
      <div>
        <ListItemButton
          onClick={handleChangeMeetingToday}
          className={style.meeting}
          disabled={disabled}
          selected={value === 'today'}
        >
          <ListItemText
            secondary={tp('today')}
            primary={dateFormat(new Date())}
            slotProps={{
              primary: {
                style: {
                  fontWeight: 'bold',
                },
              },

              secondary: {
                color: 'textSecondary',
              },
            }}
          />
        </ListItemButton>
        <MeetingList
          value={value}
          className={style.meetings}
          multiple={false}
          options={options}
          disabled={!!disabled}
          onChange={handleChangeMeeting}
        />
      </div>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};
